document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle'), drawer = document.querySelector('.menu-drawer'),
        close = document.querySelector('.drawer-close'), overlay = document.querySelector('.drawer-overlay');
  const setDrawer = open => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    toggle?.setAttribute('aria-expanded', String(open));
    if (overlay) { overlay.hidden = !open; overlay.classList.toggle('is-open', open); }
    document.body.classList.toggle('drawer-open', open);
  };
  toggle?.addEventListener('click', () => setDrawer(true));
  close?.addEventListener('click', () => setDrawer(false));
  overlay?.addEventListener('click', () => setDrawer(false));

  document.querySelectorAll('[data-product-root]').forEach(root => {
    const json = root.querySelector('[data-product-json]');
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const groups = [...root.querySelectorAll('.variant-group')];
    const idInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-price]');
    const submit = root.querySelector('.add-to-cart');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:(window.Shopify?.currency?.active || 'USD')}).format(cents/100);
    const refresh = () => {
      const selected = groups.map(g => g.querySelector('.is-selected')?.dataset.value);
      const variant = variants.find(v => v.options.every((o,i) => o === selected[i]));
      if (variant) { idInput.value = variant.id; price.textContent = money(variant.price); submit.disabled = !variant.available; submit.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT'; }
    };
    groups.forEach(g => g.querySelectorAll('.variant-button').forEach(btn => btn.addEventListener('click', () => {
      g.querySelectorAll('.variant-button').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected'); refresh();
    })));
    refresh();
  });
});